<template>
    <div class="animated fadeIn">
        <div class="card card-green">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{
                            $t('NEW')
                        }}</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12  table-responsive">
                        <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                            <thead>
                                <tr>
                                    <th>{{ $t('ID') }}</th>
                                    <th>{{ $t('USERNAME') }}</th>
                                    <th>{{ $t('USEREMAIL') }}</th>
                                    <th>{{ $t('NAME') }}</th>
                                    <th>{{ $t('SURNAME') }}</th>
                                    <th>{{ $t('COMPANYNAME') }}</th>
                                    <th>{{ $t('VISITQUOTA') }}</th>
                                    <th>{{ $t('ACTION') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in response.root" :key="item.notificationId" aria-rowindex="1"
                                    class=" table-ellipsis">
                                    <td>{{ item.userId }}</td>
                                    <td>{{ item.username }}</td>
                                    <td>{{ item.userEmail }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.surname }}</td>
                                    <td>{{ item.companyName }}</td>
                                    <td>{{ item.visitQuota }}</td>
                                    <td>
                                        <button type="button" class="btn button-edit mr-2" @click="showDocuments(item)">{{
                                            $t('DOCUMENTS')
                                        }}</button>
                                        <button type="button" class="btn button-edit mr-2" @click="showModal(item)">{{
                                            $t('EDIT')
                                        }}</button>
                                        <button type="button" class="btn button-dlt"
                                            @click="deleteRow(item.userId)">{{ $t('DELETE')
                                            }}</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <nav>
                            <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData">
                            </pagination>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <UsersForm v-model="formData" v-on:close="formData = null; getData()" />
    </div>
</template>

<script>
import Api from '@/api/admin/Users';
import UsersForm from './Form.vue';

export default
    {
        name: 'Users',
        components:
        {
            UsersForm,
        },
        data() {
            return {
                response:
                    {},
                formData: null,
                pagination:
                {
                    query: '',
                    currentPage: 1,
                    limit: 25,
                    searchTimeout: false,
                    showInactive: 0,
                },
            };
        },
        created() {
            const me = this;
            me.getData();
        },
        methods:
        {
            showDocuments(item)
            {
                const me = this;
                me.$router.push(
                    {
                        path: `/system/users/userdocuments/${item.userId}`,
                    },
                );
            },
            async getData() {
                const me = this;
                try {
                    const data = await Api.selectRow(me.getParams);
                    if (data.error && data.error === true) {
                        me.$notify.notice(data);
                        me.loading = false;
                        return;
                    }

                    for (let i = 0; i < data.root.length; i += 1)
                    {
                        data.root[i].password = '';
                        data.root[i].trhidden = false;
                    }

                    me.response = data;
                }
                catch (e) {
                    me.$notify.notice(e);
                }
            },
            async deleteRow(id) {
                const me = this;
                try {
                    me.$store.commit('setModalAlert',
                        {
                            text: me.$i18n.t('AREYOUSHURE'),
                            async btnAction() {
                                const data = await Api.deleteRow(
                                    {
                                        id,
                                    },
                                );
                                me.$notify.notice(data);
                                await me.getData();
                            },
                        });
                }
                catch (e) {
                    me.$notify.notice(e);
                }
            },
            showModal(item) {
                const me = this;
                let data = {};
                if (typeof item !== 'undefined') {
                    data = { ...item };
                }

                me.formData = data;
            },
        },
        watch:
        {
            'pagination.limit'() {
                const me = this;
                me.getData();
            },
            'pagination.currentPage'() {
                const me = this;
                me.getData();
            },
            'pagination.showInactive'() {
                const me = this;
                me.getData();
            },
            'pagination.query'() {
                const me = this;

                if (me.pagination.searchTimeout !== false) {
                    clearTimeout(me.pagination.searchTimeout);
                }

                me.pagination.searchTimeout = setTimeout(() => {
                    me.getData();
                    me.pagination.searchTimeout = false;
                }, 300);
            },
        },
        computed:
        {
            getParams() {
                const me = this;
                const data = {
                    ...me.pagination,
                };
                data.start = (data.currentPage - 1) * data.limit;
                return data;
            },
        },
    };
</script>
